import React from "react";
import { STATUS_STYLES } from "@/lib/constants";

export function StatusBadge({ status, daysOverdue }) {
  const cfg = STATUS_STYLES[status] || STATUS_STYLES["Pending"];
  const Icon = cfg.Icon;
  let label = status;
  if (status === "Overdue" && daysOverdue > 0) label = `${daysOverdue}d overdue`;
  if (status === "Expected payout missed") label = "Missed";
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${cfg.cls}`}
    >
      <Icon size={13} strokeWidth={2.2} />
      {label}
    </span>
  );
}
